
export const  QUERY_KEYS = {
    WORKBENCH: 'workbench',
    SURVEYSCREEN: 'survey-screen',
    DASHBOARD: 'dashboard',
    SAVEDRAFT: 'save-draft',
    AUDITOR_DASHBOARD: 'auditor-dashboard',
    CASE: 'case',
    CONFIGURABLE: 'configurable',
    ERRORLOG: 'error-logs',
    INTERNALTRACKERGETDATA: 'internal-tracker-get-data'
}